// removed by extract-text-webpack-plugin
module.exports = {"featureImageQuoteContent":"_3pbjaoA10UOvpQWwPoiIr8","darkFilter":"_3tI6suVprqOJ6ooCT0FFgN","quoteWrapper":"_7zjihB37oBD-WeaFzXm7t"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FeatureImageQuoteContent/FeatureImageQuoteContent.module.scss
// module id = 759
// module chunks = 0